import * as React from 'react'

export const BlankSlate = () => <div className="ViolationHistoryAvailability"></div>


// WEBPACK FOOTER //
// ./src/components/ViolationsHistoryDetails/BlankSlate.tsx